import { Badge } from "@/components/ui/badge";
import { AlertTriangle } from "lucide-react";

const TYPE_LABEL = {
  road: "Road",
  osr: "OSR",
  footpath: "Footpath",
  dumping_yard: "Dumping Yard",
  sipcot_po_office: "Project Office",
};

function toDdMmYyyy(iso) {
  if (!iso) return "—";
  const [y, m, d] = String(iso).split("-");
  if (!y || !m || !d) return iso;
  return `${d}.${m}.${y}`;
}

export function MostMissedLeaderboard({ items = [], onPick }) {
  const shown = items.slice(0, 8);
  return (
    <div className="rounded-xl border bg-white shadow-sm" data-testid="most-missed-leaderboard">
      <div className="flex items-center justify-between border-b px-4 py-3">
        <div className="flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 text-rose-600" />
          <div className="font-display text-sm font-semibold">Most-Missed Assets</div>
        </div>
        <div className="text-xs text-slate-500">{items.length} pending</div>
      </div>
      <div className="divide-y">
        {shown.length === 0 ? (
          <div className="px-4 py-6 text-center text-sm text-slate-500">Everything is on track in the current cycle. </div>
        ) : shown.map((t) => (
          <button
            key={t.asset_id}
            type="button"
            onClick={() => onPick && onPick(t)}
            className="flex w-full items-center justify-between gap-3 px-4 py-2.5 text-left transition-colors hover:bg-amber-50/60 focus:bg-amber-50 focus:outline-none"
            data-testid={`most-missed-row-${t.asset_id}`}
          >
            <div className="min-w-0">
              <div className="truncate text-sm font-medium">{t.name}</div>
              <div className="text-[11px] text-slate-500">{TYPE_LABEL[t.asset_type] || t.asset_type} · last cleaned <span className="font-mono">{toDdMmYyyy(t.last_date)}</span></div>
            </div>
            <div className="flex shrink-0 items-center gap-2">
              {t.neglect_days != null ? (
                <Badge variant="outline" className={t.neglect_days >= 14 ? "border-rose-300 bg-rose-50 text-rose-800" : "border-amber-300 bg-amber-50 text-amber-800"}>{t.neglect_days}d idle</Badge>
              ) : (
                <Badge variant="outline" className="border-slate-300 bg-slate-50 text-slate-700">Never visited</Badge>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
